import { render } from "./Login.vue?vue&type=template&id=31dd086c&scoped=true"
import script from "./Login.vue?vue&type=script&language=ts&lang=js"
export * from "./Login.vue?vue&type=script&language=ts&lang=js"

import "./Login.vue?vue&type=style&index=0&id=31dd086c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-31dd086c"

export default script